import React from 'react'
import headerStyles from './header.module.css'
import SelectLanguage from '../SelectLanguage'
import '../Content/content.css'

const Header = props => {
  const path = props.pathname.split('/')[1]
  const langPath = path == 'en-CA' ? true : path == 'board' ? true : false
  return (
    <div className={headerStyles.wrapper}>
      <div className={headerStyles.container}>
        {langPath ? (
          <ul className={headerStyles.siteTabs}>
            <li>
              <a href="http://www.crea.ca/">CREA</a>
            </li>
            <li>
              <a href="https://www.creacafe.ca/">CREA Blog</a>
            </li>
            <li>
              <a href="https://www.realtorscare.ca/">REALTORS CARE®</a>
            </li>
            <li>
              <a className={headerStyles.activeNav} href="/">
                CREA STATS
              </a>
            </li>
            <li>
              <a href="https://www.realtor.ca/" target="_blank">
                REALTOR.ca
              </a>
            </li>
          </ul>
        ) : (
          <ul className={headerStyles.siteTabs}>
            <li>
              <a href="https://www.crea.ca/fr/">ACI</a>
            </li>
            <li>
              <a href="https://www.creacafe.ca/fr/">Blogue de l'ACI</a>
            </li>
            <li>
              <a href="https://www.realtorscare.ca/fr/">REALTORS CARE®</a>
            </li>
            <li>
              <a className={headerStyles.activeNav} href="/">
                STAT. L'ACI
              </a>
            </li>
            <li>
              <a href="https://www.realtor.ca/fr" target="_blank">
                REALTOR.ca
              </a>
            </li>
          </ul>
        )}

        {langPath ? (
          <ul className={headerStyles.utilityNav}>
            <li>
              <a href="http://www.crea.ca/">Home</a>
            </li>
            <li>
              <a href="http://www.realtorlink.ca/" target="_blank">
                Member Login
              </a>
            </li>
            <li>
              <a href="https://www.crea.ca/newsroom/">Newsroom</a>
            </li>
            <li>
              <a href="https://www.crea.ca/about/careers/">Careers</a>
            </li>
            <li>
              <a href="https://www.crea.ca/contact/">Contact</a>
            </li>

            <li>
              <SelectLanguage langs={props.langs} pathname={props.pathname} />
            </li>
          </ul>
        ) : (
          <ul className={headerStyles.utilityNav}>
            <span className={headerStyles.utilityNavFr}>
              <li>
                <a href="https://www.crea.ca/fr/">Accueil</a>
              </li>
              <li>
                <a href="http://www.realtorlink.ca/" target="_blank">
                  Accès membre
                </a>
              </li>
              <li>
                <a href="https://www.crea.ca/fr/about/careers/">
                  Salle des nouvelles
                </a>
              </li>
              <li>
                <a href="https://www.crea.ca/fr/about/careers/">Carrières</a>
              </li>
              <li>
                <a href="https://www.crea.ca/fr/contact/">Pour nous joindre</a>
              </li>
              <li>
                <SelectLanguage langs={props.langs} pathname={props.pathname} />
              </li>
            </span>
          </ul>
        )}
      </div>
    </div>
  )
}

export default Header
